<template>
  <div class="listContainer" @keyup.enter="onSearch">
    <!-- 面包屑 -->
    <a-breadcrumb class="breadcrumb">
      <span slot="separator">></span>
      <a-breadcrumb-item>设备管理</a-breadcrumb-item>
      <a-breadcrumb-item>
        <a @click="backHref">网点员工</a>
      </a-breadcrumb-item>
    </a-breadcrumb>
    <!-- 面包屑 end   -->
    <!-- 增加&搜索 -->
    <section v-show="!showIsAdd && !showIsEdit">
      <section class="searchBox">
        <span class="addStyle">
          <a-button type="primary" icon="plus" @click="showIsAdd = !showIsAdd"
            >增加</a-button
          >
        </span>
        <span>
          <label>项目：</label>
          <a-select
            v-model="project_id"
            style="width:200px"
            showSearch
            :filterOption="filterOption"
            optionFilterProp="children"
            placeholder="请选择项目"
          >
            <a-select-option
              v-for="(item, i) in proList"
              :key="i"
              :value="item.id"
              >{{ item.project_name }}</a-select-option
            >
          </a-select>
        </span>
        <span>
          <label>字符串：</label>
          <a-input
            placeholder="请输入网点设备机器名称|机器码|网点详细地址|员工手机号|员工姓名"
            style="width:300px"
            v-model="query_field"
          />
        </span>
        <span>
          <a-button @click="onReset">重置</a-button>
          <a-button type="primary" icon="search" @click="onSearch"
            >搜索</a-button
          >
        </span>
      </section>
      <!-- 增加&搜索 end-->
      <section class="tableStyles">
        <table>
          <thead>
            <tr>
              <th v-for="(item, j) in thList" :key="j">{{ item }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-show="data.length < 1">
              <td></td>
              <td></td>
              <td></td>
              <td>暂无</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr v-show="data.length > 0" v-for="(item, i) in data" :key="i">
              <td>{{ item.project_name }}</td>
              <td>{{ item.device_name }}</td>
              <td>{{ item.user_name }}</td>
              <td>{{ item.phone }}</td>
              <td>{{ item.price }}</td>
              <td>{{ item.new_price }}</td>
              <td>{{ item.pretty_price }}</td>
              <td class="operation">
                <a @click="editPage(item)" style="color:#67C23A">编辑</a>
              </td>
            </tr>
          </tbody>
        </table>
      </section>
      <div class="paginationStyle" :loading="loading">
        <a-pagination
          showQuickJumper
          :defaultCurrent="page"
          :total="pagination.total"
          @change="onChange"
          :current="page"
        />
        <span>{{ "共：" + pagination.total + "条" }}</span>
      </div>
    </section>
    <!-- content end -->
    <!-- 新增 -->
    <addDeviceGuard v-show="showIsAdd" v-on:hideInAdd="hideInAdd" />
    <!-- 新增 end -->
    <!-- 编辑 -->
    <deviceGuardEdit
      v-if="showIsEdit"
      v-on:hideInEdit="hideInEdit"
      :editDetail="editDetail"
    />
    <!-- 编辑 end -->
  </div>
</template>
<script>
import axios from "axios";
import addDeviceGuard from "@/components/equipment/addDeviceGuard.vue"; //增加
import deviceGuardEdit from "@/components/equipment/deviceGuardEdit"; //编辑
export default {
  data() {
    return {
      data: [],
      loading: false,
      page: 1,
      pagination: {},
      thList: [
        "项目名称",
        "网点设备名称",
        "员工姓名",
        "员工手机号",
        "日常补货价格",
        "新品上新价格",
        "新品陈列价格",
        "操作"
      ],
      project_id: "",
      query_field: "",
      proList: [],
      showIsAdd: false,
      showIsEdit: false,
      editDetail: ""
    };
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  components: {
    addDeviceGuard,
    deviceGuardEdit
  },
  mounted() {
    this.getData(); //获取列表
    this.getPro(); //获取项目
  },
  methods: {
    editPage(item) {
      this.showIsEdit = true;
      this.editDetail = item;
    },
    hideInEdit(msg) {
      this.showIsEdit = false;
      if (msg) {
        this.reload();
      }
    },
    hideInAdd(msg) {
      this.showIsAdd = false;
      if (msg) {
        this.reload();
      }
    },
    backHref() {
      this.showIsAdd = false;
      this.showIsEdit = false;
    },
    getPro() {
      let url =
        this.httpsBasic.url + this.httpsBasic.trade + "Project/projectList";
      axios
        .post(url, {
          current_page: 1,
          per_page: 10000,
          token: window.localStorage.getItem("xnwfPcToken"),
          trade_id: 2
        })
        .then(res => {
          if (res.data.code == 200) {
            this.proList = res.data.data.data;
          } else {
            this.$message.warning(res.data.message);
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    onChange(pageNumber) {
      this.page = pageNumber;
      this.getData();
    },
    onSearch() {
      this.page = 1;
      this.getData();
    },
    reload() {
      this.$nextTick(function() {
        this.getData();
      });
    },
    onReset() {
      this.query_field = "";
      this.project_id = "";
      this.page = 1;
      this.getData();
    },
    getData() {
      // console.log(this.$store.state.token);
      this.loading = true;
      let url =
        this.httpsBasic.url + this.httpsBasic.equipment + "Device_guard/lists";
      let params = {
        current_page: this.page,
        per_page: 10,
        query_field: this.query_field,
        project_id: this.project_id,
        token: window.localStorage.getItem("xnwfPcToken")
      };
      axios
        .post(url, params)
        .then(res => {
          if (res.data.code == 200) {
            this.data = res.data.data.data;
            console.log(this.data);
            this.loading = false;
            const pagination = { ...this.pagination };
            pagination.total = res.data.data.total;
            this.pagination = pagination;
          } else {
            this.$message.warning(res.data.message);
            this.loading = false;
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="less" scoped>
@import url(../../style/listBasic.less);
.listContainer {
  td {
    img {
      height: 30px;
      width: 30px;
      object-fit: cover;
    }
  }
}
</style>
